import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemDescriptionComponent } from '@modules/common/components/item-description/item-description.component';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { SharedKnotsComponent } from '@modules/knots/components/shared-knots/shared-knots.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { NotesAppContextDirective } from '@modules/notes/directives/app-notes-app-context.directive';
import { Note } from '@modules/notes/types/note';
import { SharedTagsComponent } from '@modules/tags/components/shared-tags/shared-tags.component';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'app-note-shared',
  templateUrl: './note-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NotesAppContextDirective,
    IconComponent,
    DateFormatPipe,
    FormControlsModule,
    SharedTagsComponent,
    SharedKnotsComponent,
    SharedSignupCtaComponent,
    StchHighlightTextDirective,
    ItemDescriptionComponent,
  ],
})
export class NoteSharedComponent extends SharedBaseComponent<Note> {
  protected override readonly stitchType = StitchType.NOTE;

  protected get note(): Note {
    return this.stitchItem?.();
  }
}
